import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from '@angular/common/http';
import { Observable, map } from 'rxjs';

@Injectable()
export class SessionInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (sessionStorage.getItem('correlation-id') !== null) {
      request = request.clone({
        setHeaders: {
          'correlation-id': sessionStorage.getItem('correlation-id')!,
        },
      });
    }

    if (request.url.includes('prompt')) {
      return next.handle(request).pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            if (event.headers.get('correlation-id') !== null) {
              sessionStorage.setItem('correlation-id', event.headers.get('correlation-id')!);
            }
          }
          return event;
        })
      );
    }

    request = request.clone({
      withCredentials: true,
    });

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (event.headers.get('correlation-id') !== null) {
            sessionStorage.setItem('correlation-id', event.headers.get('correlation-id')!);
          }
        }
        return event;
      })
    );
  }
}
